// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
Vue.prototype.$layer = layer(Vue);
import VeeValidate, {Validator} from 'vee-validate'

Vue.config.productionTip = false


Vue.use(VeeValidate)

Validator.extend('isMobile', {
	getMessage: (field, args) => {
		return '手机号码格式不正确';
	},
	validate: (value, args) => {
		return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value)
	}
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js